import React, { ReactElement } from "react";
import { UseSelectGetItemPropsOptions } from "downshift";

import { DropdownItem, DropdownItemInterface } from "./DropdownItem";

interface RenderItemsOptions<Item> {
  items: Item[];
  highlightedIndex: number;
  getItemProps: (
    options: UseSelectGetItemPropsOptions<DropdownItemInterface>
  ) => any;
}
export interface RenderItems<Item> {
  ({
    items,
    highlightedIndex,
    getItemProps,
  }: RenderItemsOptions<Item>): ReactElement[];
}

export const defaultRenderItems: RenderItems<DropdownItemInterface> = ({
  items,
  highlightedIndex,
  getItemProps,
}) => {
  return items.map((item, index) => (
    <DropdownItem
      item={item}
      key={index}
      index={index}
      highlightedIndex={highlightedIndex}
      getItemProps={getItemProps}
    />
  ));
};

export interface OnSelectedItemChange {
  (selectedItem: DropdownItemInterface | ReactElement): void;
}

export const defaultOnSelectedItemChange: OnSelectedItemChange = (
  selectedItem: DropdownItemInterface
): void => {
  !selectedItem.disabled && selectedItem.action();
};
